import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const AgreementLetterObservation = () => {
  const fileStatus = 36;
  const applicationPath = {
    copyright: "/admin/copyright-letter-observation",
    agreement: "/admin/agreement-letter-observation",
  };
  const objectRoute = {
    11: "/admin/hearing-agreement-details",
    21: "/admin/letter-of-correction-agreement-details",
    27: "/admin/recorded-agreement-details",
    29: "/admin/unauthorized-agreement-details",
  };
  const pageTitle = "চিঠি পর্যবেক্ষণ";
  return (
    <SubmittedAgreement
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      objectRoute={objectRoute}
      pageTitle={pageTitle}
    />
  );
};

export default AgreementLetterObservation;
